import {ChangeDetectionStrategy, Component} from '@angular/core'
import {TranslocoService} from '@ngneat/transloco'
import {Language} from '../../../../core/i18n/language'
import {PUBLIC_ROUTES} from '../../../routing/public.routes'
import {LinkService} from '../../../../core/i18n/link.service'

@Component({
  selector: 'bgo-hero-mobiliar-partnership',
  templateUrl: './hero-mobiliar-partnership.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeroMobiliarPartnershipComponent {
  readonly Language = Language
  readonly mobiliarPartnershipPage = this.linkService.localizedPathTo(PUBLIC_ROUTES.ARTICLE_PAGE, {
    routeParams: {pageSlug: 'partner-mobiliar'},
  })

  constructor(
    readonly translocoService: TranslocoService,
    private readonly linkService: LinkService,
  ) {}
}
